import {useContext} from 'react'

import {MessagingContext} from '../context.js'

export const useMessagingContext = () => useContext(MessagingContext)
